import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  IContactUsRequest,
  IContactUsResponse,
} from '../../models/contacts/contacts.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useSetContactUs = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);

  const onCreateContactUsError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Unable to contact CCL');
  };

  const onCreateContactUsSuccess = ({
    message,
    data,
  }: SuccessHttpResponse<IContactUsResponse>) => {
    setResetInputFields(true);
    toast.success(message);
  };

  const contactUs = (data: IContactUsRequest) => {
    const url: HttpConfig = {
      url: `contact-us`,
      method: 'post',
      data,
    };

    request(url, onCreateContactUsSuccess, setLoading, onCreateContactUsError);
  };

  return { contactUs, loading, resetInputFields };
};

export default useSetContactUs;
